import { DialogContent as MUIDialogContent, DialogContentProps } from '@mui/material';
import { IComponentWithCustomScrollbarProps } from '../../../../services';
import { mergeSX } from '../../../../services/helpers';
import { ScrollableBox } from '../../../ScrollableContainers';

const buildSX = ({
  paddingTop,
  paddingBottom,
}: IBuildSXParams) => ({
  paddingX: 2,
  paddingTop,
  paddingBottom,
});

interface IBuildSXParams {
  paddingTop: number | string;
  paddingBottom: number | string;
}

interface IDialogContentProps extends DialogContentProps, IComponentWithCustomScrollbarProps {
  paddingTop?: number | string;
  paddingBottom?: number | string;
}

const SCROLLABLE_BOX_SX = { height: '100%' };

const DialogContent = (props: IDialogContentProps) => {
  const {
    children,
    paddingTop = 3,
    paddingBottom = 2,
    sx,
    disableCustomScrollbar = false,
    ...restProps
  } = props;

  const dialogContentElement = (
    <MUIDialogContent
      sx={mergeSX(buildSX({ paddingTop, paddingBottom }), sx)}
      {...restProps}
    >
      {children}
    </MUIDialogContent>
  );

  if (disableCustomScrollbar) {
    return dialogContentElement;
  }

  return (
    <ScrollableBox sx={SCROLLABLE_BOX_SX}>
      {dialogContentElement}
    </ScrollableBox>
  );
};

export default DialogContent;
